<template>
  <div>
    <Head title="Impuestos de productos" />
    <h1 class="mb-8 text-3xl font-bold">Impuestos</h1>
    <div class="flex max-w-3xl justify-between mb-6">
      <search v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">        
      </search>
      <Link class="btn-sky" href="/settings/products/taxes/create">
        <span>Crear</span>
        <span class="hidden md:inline">&nbsp;Impuesto</span>
      </Link>
    </div>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-2">Descripción</th>
          <th class="pb-4 pt-6 px-2">Porcentaje</th>
          <th class="pb-4 pt-6 px-2">Fecha de creación</th>
          <th class="pb-4 pt-6 px-2">Eliminar</th>
        </tr>
        <tr v-for="tax in productsTax.data" :key="tax.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">                         
            <Link class="flex items-center px-6 py-4" :href="`/settings/products/taxes/${tax.id}/edit`">{{ tax.descripcion }}</Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/products/taxes/${tax.id}/edit`">{{ tax.percentage }}</Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/products/taxes/${tax.id}/edit`">{{ tax.fecha }}</Link>
          </td>
          <td class="border-t">
            <button class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900" @click="removeClient(tax.id)">
              Eliminar                        
            </button>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/products/taxes/${tax.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
          
        </tr>
        <tr v-if="productsTax.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="3">No se encontraron impuestos registrados.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="productsTax.links" />
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import mapValues from 'lodash/mapValues'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import Search from '@/Shared/Search'
import Pagination from '@/Shared/Pagination'
import Swal from 'sweetalert2'
      
export default {
  components: {
    Head,
    Link,
    SearchFilter,
    Icon,
    Search,
    Pagination,

  },
  layout: Layout,
  props: {
    filters: Object,
    productsTax: Array,
    codes: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        code: this.filters.code,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/settings/products/taxes', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    removeClient(idTax){
      Swal.fire({
        title:'Remover Impuesto',
        text:'¿Desea remover el impuesto?',
        icon:'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Remover',
      }).then((result)=>{
        if(result.isConfirmed){
          this.$inertia.put(`/settings/products/taxes/delete/${idTax}`)
        }
      });
    }
  },
}
</script>